if (window.matchMedia('(max-width:640px)').matches) {
  $(function () {
    $.uHatSP.switchHatSP();
  });
  $.uHatSP = {
    switchHatSP: function (settings) {
      uHatSPConA = $.extend(
        {
          switchBtn: '.js-sp-toggleBtn',
          switchContents: '.js-sp-toggleBody',
          switchClickAddClass: 'is-active',
        },
        settings
      );
      $(uHatSPConA.switchContents).hide();
      $(uHatSPConA.switchBtn)
        .addClass('switchOn')
        .click(function () {
          var index = $(uHatSPConA.switchBtn).index(this);
          $(uHatSPConA.switchContents).eq(index).slideToggle();
          $(this).toggleClass(uHatSPConA.switchClickAddClass);
        })
        .css('cursor', 'pointer');
    },
  };
}
